// extracted by mini-css-extract-plugin
module.exports = {"appBoar":"AppBoar_appBoar__bYZX-","appBoar_tab":"AppBoar_appBoar_tab__2rxDM","appBoar_content":"AppBoar_appBoar_content__L2JiG","appBoar_item":"AppBoar_appBoar_item__2aLy9"};